import { useEffect, useState } from 'react'

/**
 * Proposer un produit, ecran 3 : « Une photo de votre produit »
 * (prototype v7.4, WizardOffre/prop.photo). OBLIGATOIRE — « c'est elle que le
 * client verra » : un grand cadre pointille de 150 px, qui devient la photo
 * elle-meme une fois choisie. Pas de description, pas d'options : une decision.
 */
function StepProposePhoto({ photo, onPhotoChange }) {
  const [apercu, setApercu] = useState(null)

  useEffect(() => {
    if (!photo) { setApercu(null); return undefined }
    const url = URL.createObjectURL(photo)
    setApercu(url)
    return () => URL.revokeObjectURL(url)
  }, [photo])

  return (
    <div>
      <p className="text-[11.5px] font-bold mb-3" style={{ color: 'rgb(var(--c-primary))' }}>
        Obligatoire — c'est elle que le client verra.
      </p>
      <label
        className="w-full h-[150px] rounded-[20px] overflow-hidden cursor-pointer flex items-center justify-center text-sm font-bold"
        style={photo
          ? { border: '1.5px solid rgb(var(--c-teal))', background: 'rgb(var(--c-teal) / 0.08)', color: 'rgb(var(--c-teal))' }
          : { border: '1.5px dashed rgba(7,62,61,0.25)', background: 'rgba(255,255,255,0.5)', color: 'rgba(7,62,61,0.6)' }}
      >
        {apercu
          ? <img src={apercu} alt="" className="w-full h-full object-cover" />
          : '📷 Prendre / choisir une photo'}
        <input
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => onPhotoChange(e.target.files?.[0] || null)}
        />
      </label>
      {photo && (
        <button onClick={() => onPhotoChange(null)} className="mt-2.5 text-[12px] font-bold text-ink/55">
          ✕ Changer de photo
        </button>
      )}
    </div>
  )
}

export default StepProposePhoto
